// AUTO-GENERATED by scripts/gen-icon-shim.mjs - Do not edit manually
// Lucide re-exports + overrides — import via: import { Name } from "lucide-react"
import * as React from "react";
import { ArrowDown, ArrowLeft, ArrowRight, CalendarPlus, Captions, CaptionsOff, Check, CheckIcon, ChevronDownIcon, ChevronLeft, ChevronRight, ChevronRightIcon, ChevronUpIcon, CircleCheckIcon, CircleIcon, Download, ExternalLink, Globe, ImageIcon, Info, InfoIcon, Loader2, Loader2Icon, Mail, MapPin, Maximize, Maximize2, Menu, MessageSquare, Minimize, MoreHorizontal, OctagonXIcon, Pause, Phone, PictureInPicture2, Play, Share2, ShieldAlert, TriangleAlertIcon, Volume2, VolumeX, X, ZoomIn, ZoomOut } from "lucide-react-original";
import StarIconSvg from "../../../../packages/corekit/src/app/_assets/shared/icons/star.svg";
import MapPinIconSvg from "../app/_assets/icons/map-pin.svg";
// Re-export Lucide icons that are not overridden
export { ArrowDown };
export { ArrowLeft };
export { ArrowRight };
export { CalendarPlus };
export { Captions };
export { CaptionsOff };
export { Check };
export { CheckIcon };
export { ChevronDownIcon };
export { ChevronLeft };
export { ChevronRight };
export { ChevronRightIcon };
export { ChevronUpIcon };
export { CircleCheckIcon };
export { CircleIcon };
export { Download };
export { ExternalLink };
export { Globe };
export { ImageIcon };
export { Info };
export { InfoIcon };
export { Loader2 };
export { Loader2Icon };
export { Mail };
export { MapPin };
export { Maximize };
export { Maximize2 };
export { Menu };
export { MessageSquare };
export { Minimize };
export { MoreHorizontal };
export { OctagonXIcon };
export { Pause };
export { Phone };
export { PictureInPicture2 };
export { Play };
export { Share2 };
export { ShieldAlert };
export { TriangleAlertIcon };
export { Volume2 };
export { VolumeX };
export { X };
export { ZoomIn };
export { ZoomOut };
// Custom SVG overrides (these names exist in Lucide)
export const StarIcon = (props) => React.createElement(StarIconSvg, props);
export const MapPinIcon = (props) => React.createElement(MapPinIconSvg, props);